import { computed, get } from '@ember/object';

export default function itemAtPropertyIndex(arrayKey, indexKey) {
  return computed(`${arrayKey}.[]`, indexKey, function () {
    return get(this, arrayKey)[get(this, indexKey)];
  });
}
